var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.explanation)?_c('v-alert',{staticClass:"page-explanation mx-4 mt-3 mb-3",attrs:{"type":"info","dense":"","outlined":"","data-testid":`page-explanation-${_vm.pageKey}`}},[_vm._v(" "+_vm._s(_vm.explanation)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }